export const Country = Object.freeze({
  AU: 'AU',
  NZ: 'NZ',
  UNKNOWN: 'UNKNOWN'
})

export const CountryNumberPrefix = Object.freeze({
  AU: '+61',
  NZ: '+64'
})

export const RESPONSE_RESPONSE_MESSAGE = Object.freeze({
  NO_CONTENT_MESSAGE: '204 No Content',
  REQUEST_TIMEOUT_MESSAGE: '408 Request Timeout',
  NOT_FOUND_MESSAGE: '404 Not Found'
})

export const IDLE_TIMEOUT_MS = 1000 * 60 * 10
export const LAST_ACTIVITY_DEBOUNCE_MS = 500
